import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Services from './pages/Services';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Contact from './pages/Contact';
import AdminDashboard from './pages/AdminDashboard';
import DealerDashboard from './pages/DealerDashboard';
import DealerProfile from './pages/DealerProfile';
import Login from './auth/Login';
import Categories from './pages/Categories';
import UserDashboard from './pages/UserDashboard';
import HowSearchWorks from './components/HowSearchWorks';
import AboutUs from './pages/AboutUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsPolicy from './pages/TermsPolicy';
import TermsOfService from './pages/TermsOfService';
import FAQ from './pages/FAQ';
import BlogPage from './pages/BlogPage';
import PostBlog from './pages/PostBlog';
import BlogDetails from './pages/BlogDetails';
import UserDashboardWrapper from './pages/UserDashboardWrapper';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/dealer" element={<DealerDashboard />} />
        {/* <Route path="/user" element={<UserDashboard />} /> */}
        <Route path="/user" element={<UserDashboardWrapper />} />
        <Route path="/dealers/:dealerId" element={<DealerProfile />} />
        <Route path="/login" element={<UserDashboard />} />
        <Route path="/categories" element={<Navigate to="/categories/realestate" replace />} />
        <Route path="/categories/:category" element={<Categories />} />
        <Route path="/howsearchworks" element={<HowSearchWorks />} />
        <Route path="/dealers" element={<Categories />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/termsandconditions" element={<TermsPolicy />} />
        <Route path="/termsofservice" element={<TermsOfService />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/post-blog" element={<PostBlog />} />
        <Route path="/blogs/:id" element={<BlogDetails />} />
        
      </Routes>
    </Router>
  );
};

export default App;
